import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Wrapper = styled.div`
  ${({ grids }) => css`
    display: grid;
    grid-template-columns: repeat(${grids}, 1fr);
    gap: 1.5rem;

    @media (max-width: 425px) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;
